import produce from 'immer';
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  SILENT_LOGIN,
  UPDATE_PROFILE,
} from 'actions/accountActions';

const initialState = {
  user: null,
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST: {
      return produce(state, (draft) => {
        // Ensure we clear current session
        draft.user = null;
      });
    }

    case LOGIN_SUCCESS: {
      const { name } = action.payload;

      return produce(state, (draft) => {
        draft.user = name;
      });
    }

    case LOGIN_FAILURE: {
      return produce(state, () => {
        // Maybe store error
      });
    }

    case LOGOUT: {
      return produce(state, (draft) => {
        draft.user = null;
      });
    }

    case SILENT_LOGIN: {
      const { name } = action.payload;

      return produce(state, (draft) => {
        draft.user = name;
      });
    }

    case UPDATE_PROFILE: {
      const { name } = action.payload;

      return produce(state, (draft) => {
        draft.user = name;
      });
    }

    default: {
      return state;
    }
  }
};

export default accountReducer;
